module.exports = __webpack_public_path__ + "img/logo-seenjab.17e4d376.png";